export default {
  TOP: 'top',
  BOTTOM: 'bottom',
};
